import React, { useCallback, useState } from 'react';
import { useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

import useMemberGrade from '@ecp/common/src/hooks/member/useMemberGrade';
//import theme from '@ecp/common/src/style/theme/default';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { TextBox } from '@ecp/common/src/text/TextBox';
import TabGroup from '@ecp/common/src/components/tab/TabGroup';
import { TabPanel } from '@ecp/common/src/components/tab/TabPanel';

import { userInfoState } from '@fo-recoil/common/user/atom';
import myMembershipApi from '@fo-apis/myPage/myMembershipApi';
import AllBenefitTab from '@fo-pages/home/gnb/sideFloating/AllBenefitTab';
import AvailableBenefitTab from '@fo-pages/home/gnb/sideFloating/AvailableBenefitTab';
import MembershipInfo from '@fo-pages/home/gnb/sideFloating/MembershipInfo';

const EmployeeBenefit = ({ onClose }) => {
  const theme = useTheme();
  const { userName } = useRecoilValue(userInfoState) || {};
  const { memberNumber } = useRecoilValue(userInfoState);
  const [tabIndex, setTabIndex] = useState(location?.state?.defaultTabIndex ?? 0);
  const [infoChanged, setInfoChanged] = useState(false);

  const { gradeInfo } = useMemberGrade({ myMembershipApi, memberNumber });

  const changeTabIndex = useCallback(
    (e) => {
      setTabIndex(Number(e.target.value));
    },
    [setTabIndex]
  );

  const handleDrawerClose = () => {
    onClose();
  };

  return (
    <>
      <Spacing top={30} />
      <FlexBox>
        <TitleTexBox color={theme.color.primary}>{userName}</TitleTexBox>
        <TitleTexBox>님</TitleTexBox>
      </FlexBox>
      <TitleTexBox>임직원 혜택을 안내해 드릴게요.</TitleTexBox>
      <Spacing top={30} />
      <MembershipInfo gradeInfo={gradeInfo} infoChanged={infoChanged} onClose={onClose} />
      <Spacing top={30} />
      <TitleTexBox>한눈에 확인하는 임직원 혜택</TitleTexBox>
      <Spacing top={20} />
      <TabGroup
        height="60px"
        tabItems={[
          {
            tabName: `사용 가능 혜택`,
          },
          {
            tabName: `전체 혜택 정보`,
          },
        ]}
        onChange={changeTabIndex}
        value={tabIndex}
        width={'100%'}
      >
        <TabPanel>
          {
            <AvailableBenefitTab
              gradeInfo={gradeInfo}
              handleDrawerClose={handleDrawerClose}
              setInfoChanged={setInfoChanged}
            />
          }
        </TabPanel>
        <TabPanel>{<AllBenefitTab handleDrawerClose={handleDrawerClose} />}</TabPanel>
      </TabGroup>
    </>
  );
};

export default EmployeeBenefit;

EmployeeBenefit.propTypes = {
  onClose: PropTypes.func,
};

const TitleTexBox = styled(TextBox)`
  font-size: ${(props) => props.theme.font.size.medium};
  font-weight: ${(props) => props.theme.font.weight.medium};
  line-height: 34px;
`;
